var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{domProps:{"innerHTML":_vm._s(_vm.bookName)}})
}
var staticRenderFns = []

export { render, staticRenderFns }